import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/singlegame-forced-stacking/actions';

class CombinationChecking extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.set('CombinationIsChecked', this.props.comboKey, isChecked));
    }

    render() {
        const {comboKey, stacking} = this.props;
        const isChecked = stacking.isCombinationChecked(comboKey);

        return (
            <label>
                <input
                    value="1"
                    type="checkbox"
                    onChange={(e) => ::this.onChange(e.target.checked)}
                    checked={isChecked}
                    className="form-control"
                />
            </label>
        );
    }
}

function mapStatesToProps(state) {
    const {singlegameForcedStacking} = state;

    return {
        stacking: singlegameForcedStacking.settings,
    };
}

export default connect(mapStatesToProps)(CombinationChecking);
